import './styles/vip-hub.scss';
import React, { useContext } from 'react';
import _ from 'lodash';
import classNames from 'classnames';
import { AppContext } from './store/contexts/AppContext';
import { NavigationContext } from './store/contexts/NavigationContext';
import { Routes, Route } from "react-router-dom";
import { Benefits, Inspiration, Personal, Style, GuestUserPrompt } from './views/';

export function App() {

	const context = useContext(AppContext);
	const { location } = useContext(NavigationContext);
	const {canInitalRender, isUserLoggedIn, activeView, allowGuestAccess, guestExpiryTime } = context;
	const LoggedInDependancy = ( allowGuestAccess || isUserLoggedIn )  ? <Personal/> : <Benefits/>;
	const altnerateEntrypoints = {
		'style':<Style/>
	};
	
	const shouldRenderInspirationOverlay = _.includes(location.pathname,'inspiration');
	const activeComponent = _.get(altnerateEntrypoints, activeView, LoggedInDependancy);
	const shouldRenderGustUserPrompt = !!(Date.now() > guestExpiryTime) && guestExpiryTime;
	
	return ( canInitalRender && <div className={`lexus-campaigns`} >
		<Routes>
          	<Route path="benefits/:sectionId?" element={<Benefits/>} />
			<Route path="personal/:sectionId?" element={LoggedInDependancy} />
			<Route path="style" element={<Style/>} />
          	<Route path="*" element={activeComponent} />
		</Routes>

			{shouldRenderInspirationOverlay && <Inspiration />}
			{shouldRenderGustUserPrompt && <GuestUserPrompt />}
		</div>
  );
}